"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEtag = void 0;
// @ts-nocheck
var sha1 = require("js-sha1");
var types_1 = require("./types");
var utils_1 = require("./utils");
function getArrayBuffer(file) {
    var reader = new FileReader();
    reader.readAsArrayBuffer(file);
    return new Promise(function (resolve, reject) {
        reader.onload = function (event) {
            resolve(event.target.result);
        };
        reader.onerror = reject;
    });
}
function getEtag(file) {
    return __awaiter(this, void 0, void 0, function () {
        function concatArr2Uint8(s) {
            //Array 2 Uint8Array
            var tmp = [];
            for (var _i = 0, s_1 = s; _i < s_1.length; _i++) {
                var i = s_1[_i];
                tmp = tmp.concat(i);
            }
            return new Uint8Array(tmp);
        }
        function Uint8ToBase64(u8Arr, urisafe) {
            //Uint8Array 2 Base64
            var CHUNK_SIZE = 0x8000; //arbitrary number
            var index = 0;
            var length = u8Arr.length;
            var result = '';
            var slice;
            while (index < length) {
                slice = u8Arr.subarray(index, Math.min(index + CHUNK_SIZE, length));
                result += String.fromCharCode.apply(null, slice);
                index += CHUNK_SIZE;
            }
            return urisafe
                ? btoa(result).replace(/\//g, '_').replace(/\+/g, '-')
                : btoa(result);
        }
        function calcEtag() {
            if (!sha1String.length)
                return 'Fto5o-5ea0sNMlW_75VgGJCv2AcJ';
            var sha1Buffer = concatArr2Uint8(sha1String);
            // 如果大于4M，则对各个块的sha1结果再次sha1
            if (blockCount > 1) {
                prefix = 0x96;
                sha1Buffer = shA1(sha1Buffer.buffer);
            }
            else {
                sha1Buffer = Array.apply([], sha1Buffer);
            }
            sha1Buffer = concatArr2Uint8([[prefix], sha1Buffer]);
            return Uint8ToBase64(sha1Buffer, true);
        }
        var buffer, shA1, blockSize, sha1String, prefix, blockCount, bufferSize, i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getArrayBuffer(file).catch(function (error) {
                        throw new utils_1.Error({
                            code: types_1.ErrorCode.CheckFileFail,
                            message: 'Get file etag failed',
                            error: error
                        });
                    })
                    // sha1算法
                ];
                case 1:
                    buffer = _a.sent();
                    shA1 = sha1.digest;
                    blockSize = 4 * 1024 * 1024;
                    sha1String = [];
                    prefix = 0x16;
                    blockCount = 0;
                    bufferSize = buffer.size || buffer.length || buffer.byteLength;
                    blockCount = Math.ceil(bufferSize / blockSize);
                    for (i = 0; i < blockCount; i++) {
                        sha1String.push(shA1(buffer.slice(i * blockSize, (i + 1) * blockSize)));
                    }
                    return [2 /*return*/, calcEtag()];
            }
        });
    });
}
exports.getEtag = getEtag;
